import React from 'react'
import PropTypes, { number, string } from 'prop-types'
import styled from 'styled-components'
import { CircularProgressbar } from 'react-circular-progressbar'
import classNames from 'classnames'

const Holder = styled.div`
  width: 150px;
  height: 150px;
  margin: 0 auto;
  box-shadow: 
    0 8px 32px rgba(237, 162, 17, 0.3),
    0 2px 8px rgba(237, 162, 17, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border: 2px solid rgba(237, 162, 17, 0.2);
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(
      135deg,
      rgba(237, 162, 17, 0.3) 0%,
      transparent 50%,
      rgba(237, 162, 17, 0.1) 100%
    );
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 
      0 12px 40px rgba(237, 162, 17, 0.4),
      0 4px 12px rgba(237, 162, 17, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    
    &::before {
      opacity: 1;
    }
  }
`

export default function ProgressCircle({ value = 0, fakeProgress = false }) {
  const styles = {
    root: {},
    path: {
      stroke: '#EDA211',
    },
    trail: {
      stroke: 'rgb(38, 34, 35)',
    },
    text: {
      fill: '#fff',
      fontWeight: 'bold',
      fontSize: '24px',
    },
  }

  return (
    <Holder>
      <CircularProgressbar
        className={classNames('progressCircleColor')}
        value={fakeProgress ? 100 : value}
        styles={styles}
        strokeWidth={5}
        text={fakeProgress ? value : `${value}%`}
      />
    </Holder>
  )
}

ProgressCircle.propTypes = {
  value: PropTypes.oneOfType([string, number]),
}
